import { Stack } from "expo-router";
import Head from "expo-router/head";
import { View } from "react-native";

import { ViewAsBanner } from "../../components/admin/ViewAsBanner";
import { PANE_THEMES } from "../../components/brand/paneThemes";
import { isImpersonating } from "../../lib/impersonate";
import { PortalGate } from "../../lib/PortalGate";

export default function StudentLayout() {
  const impersonating = isImpersonating();
  return (
    <>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <PortalGate portal="student">
        <View style={{ flex: 1 }}>
          {impersonating ? <ViewAsBanner theme={PANE_THEMES.Student} /> : null}
          <View style={{ flex: 1 }}>
            <Stack screenOptions={{ headerShown: false }} />
          </View>
        </View>
      </PortalGate>
    </>
  );
}
